import { render, staticRenderFns } from "./LeftFilterSidebarSummary.vue?vue&type=template&id=49205958&scoped=true"
import script from "./LeftFilterSidebarSummary.vue?vue&type=script&lang=js"
export * from "./LeftFilterSidebarSummary.vue?vue&type=script&lang=js"
import style0 from "./LeftFilterSidebarSummary.vue?vue&type=style&index=0&id=49205958&prod&lang=scss"
import style1 from "./LeftFilterSidebarSummary.vue?vue&type=style&index=1&id=49205958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49205958",
  null
  
)

export default component.exports